'use strict';

import {set, get, init, toString} from './helpers';

export default function Base(){

  var obj = {

    className: 'Base',

    set(...args){
      return set.call(this, ...args);
    },

    get(key){
      return get.call(this, key);
    },

    init(options){
      return init.call(this, options || {});
    },

    toString(){
      return toString.call(this);
    }

  };


  return Object.create(obj);

}



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/Base.js
 **/